"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_assignedRepaymentTape = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
// eslint-disable-next-line camelcase
const uinode_1 = require("../generated-repayment-tape/uinode");
const configSchema = __importStar(require("./schema/UIConfig.jsonschema.generated.json"));
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, configSchema);
const createNewNode = ({ id, loanProductSlug, creditFacilitySlug, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = 'Assigned Repayment';
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${lodash_1.default.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            loanProductSlug,
            creditFacilitySlug,
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = lodash_1.default.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = (0, utils_1.updateArtifactSlug)(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
/**
 * Validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const { artifactSlug, creditFacilitySlug } = node.configuration;
    const errors = [];
    const edgeErrors = (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => {
            return uiNode.nodeType === 'file_generatedRepaymentTape';
        },
        getUINode,
        minInputs: 1,
        maxInputs: 1,
        // This node currently only expected to be connected to BBR.
        // Can also have no outputs as well if we wanted
        minOutputs: 0,
        maxOutputs: 1,
    });
    edgeErrors.forEach((err) => errors.push(err));
    const inputNodes = (0, utils_1.getSourceNodes)({ node, graph });
    // Already checked input length above with "checkEdges",
    // so can expect the length to be one here
    const generatedRepayment = inputNodes[0];
    if (uinode_1.file_generatedRepaymentTape.isNode(generatedRepayment)) {
        const generatedCf = generatedRepayment.configuration.creditFacilitySlug;
        // Recall that "credit facility" could be null for generated repayment
        // tape depending on the loan tape type for this loan product.
        // Just want to check if present, it's the same as assigned repayment.
        if (generatedCf) {
            if (generatedCf !== creditFacilitySlug) {
                errors.push(`Assigned Repayment Tape [${artifactSlug}] input must have same credit facility as generated repayment tape input node [${generatedRepayment.configuration.artifactSlug}]`);
            }
        }
    }
    else {
        errors.push(`Assigned Repayment Tape [${artifactSlug}] input must be a generated repayment tape, received [${generatedRepayment.metadata.tapeBuilderNodeType}]`);
    }
    return errors;
};
/**
 * Represents a UI node with various properties and methods.
 */
// eslint-disable-next-line camelcase
exports.file_assignedRepaymentTape = {
    // What tape-builder node displays on UI creation menu.
    nodeTypeText: 'Assigned Repayment',
    // The node type, which is one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    badgeTexts: ['Assigned', 'Repayment'],
    // Schema to validate the configuration against.
    configSchema,
    // Creates sample configuration for this node.
    createNewNode,
    // Typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // Validate the configuration for the node for logical correctness
    hasValidConfig,
    validateIntermediateTape: () => [],
};
//# sourceMappingURL=uinode.js.map